import { ColumnFormat, ColumnRawData } from '../../well-known-type';

// Not official, but according to my search result, you could reference
// key of column: {AdsAppsMT}/private/Campaign/MT/Source/Interface/Entity/Aggregator2/GridColumn.cs
// name of column: {AdsAppsMT}/private/Campaign/MT/Source/Shared/InlineDownload/Source/Helpers/ServiceHelpers.cs
// name of column: {AdsAppsCampaignUI}/private/ui-legacy/Localization/CampaignUIClientSide/strings.resx

export const spendColumn: ColumnRawData = {
  key: 'Spend',
  name: _TL_('Spend'),
  helpId: 'Page_CampaignGrids_Spend',
};

export const clicksColumn: ColumnRawData = {
  key: 'Clicks',
  name: _TL_('Clicks'),
  format: ColumnFormat.Integer,
  helpId: 'Page_CampaignGrids_Clicks',
};

export const impressionsColumn: ColumnRawData = {
  key: 'Impressions',
  name: _TL_('Impr.'),
  format: ColumnFormat.Integer,
  helpId: 'Page_CampaignGrids_Impr',
};

export const CTRColumn: ColumnRawData = {
  key: 'CTR',
  name: _TL_('CTR'),
  format: ColumnFormat.PercentageValue,
  helpId: 'Page_CampaignGrids_CTR',
};

export const averageCPCColumn: ColumnRawData = {
  key: 'AverageCPC',
  name: _TL_('Avg. CPC'),
  helpId: 'Page_CampaignGrids_AvgCPC',
};

export const averageCPMColumn: ColumnRawData = {
  key: 'AverageCPM',
  name: _TL_('Avg. CPM'),
  helpId: 'Page_CampaignGrids_AvgCPM',
};

export const conversionsColumn: ColumnRawData = {
  key: 'Conversions',
  name: _TL_('Conv.'),
  format: ColumnFormat.Integer,
  helpId: 'Page_CampaignGrids_Conv',
};

export const conversionRateColumn: ColumnRawData = {
  key: 'ConversionRate',
  name: _TL_('Conv. rate'),
  format: ColumnFormat.PercentageValue,
  helpId: 'Page_CampaignGrids_ConvRate',
};

export const grossRevenueColumn: ColumnRawData = {
  key: 'GrossRevenue',
  name: _TL_('Gross revenue'),
  format: ColumnFormat.Decimal,
};

export const grossRevenuePerConvColumn: ColumnRawData = {
  key: 'GrossRevenuePerConv',
  name: _TL_('Gross revenue per conv.'),
  format: ColumnFormat.Decimal,
};

export const grossRevenuePerClickColumn: ColumnRawData = {
  key: 'GrossRevenuePerClick',
  name: _TL_('Gross revenue per click'),
  format: ColumnFormat.Decimal,
};

export const grossROASColumn: ColumnRawData = {
  key: 'GrossROAS',
  name: _TL_('Gross ROAS'),
  format: ColumnFormat.Decimal,
};

export const netRevenueColumn: ColumnRawData = {
  key: 'NetRevenue',
  name: _TL_('Net revenue'),
  format: ColumnFormat.Decimal,
};

export const netRevenueConvColumn: ColumnRawData = {
  key: 'NetRevenueConv',
  name: _TL_('Net revenue per conv.'),
  format: ColumnFormat.Decimal,
};

export const netRevenuePerClickColumn: ColumnRawData = {
  key: 'NetRevenuePerClick',
  name: _TL_('Net revenue per click'),
  format: ColumnFormat.Decimal,
};

export const netROASColumn: ColumnRawData = {
  key: 'NetROAS',
  name: _TL_('Net ROAS'),
  format: ColumnFormat.Decimal,
};

export const totalBookedNightsColumn: ColumnRawData = {
  key: 'TotalBookedNights',
  name: _TL_('Booked length of stay'),
  format: ColumnFormat.Integer,
};

export const avgBookedABWColumn: ColumnRawData = {
  key: 'AvgBookedABW',
  name: _TL_('Avg booked ABW'),
  format: ColumnFormat.Decimal,
};

export const bookedABWColumn: ColumnRawData = {
  key: 'BookedABW',
  name: _TL_('Booked ABW'),
  format: ColumnFormat.Integer,
};

export const returnOnAdSpendColumn: ColumnRawData = {
  key: 'RevenueOnAdSpend',
  name: _TL_('Return on ad spend'),
  format: ColumnFormat.PercentageValue,
  helpId: 'Page_CampaignGrids_ReturnAdSpend',
};

export const absoluteTopImpressionRateColumn: ColumnRawData = {
  key: 'AbsoluteTopImpressionRate',
  name: _TL_('Abs. top impr. rate'),
  format: ColumnFormat.PercentageValue,
  helpId: 'pop_BA_Reporting_Clarity_AbsoluteTopImpressionRate',
};

export const advertiserReportedRevenue: ColumnRawData = {
  key: 'AdvertiserReportedRevenue',
  name: _TL_('Revenue'),
  helpId: 'Page_CampaignGrids_Revenue',
};

export const CPAColumn: ColumnRawData = {
  key: 'CPA',
  name: _TL_('CPA'),
  helpId: 'Page_CampaignGrids_CPA',
};

export const allConversionsColumn: ColumnRawData = {
  key: 'AllConversions',
  name: _TL_('All conv.'),
  format: ColumnFormat.Integer,
  helpId: 'pop_BA_CampaignGrids_AllConv',
};

export const allConversionRateColumn: ColumnRawData = {
  key: 'AllConversionRate',
  name: _TL_('All conv. rate'),
  format: ColumnFormat.PercentageValue,
  helpId: 'pop_BA_CampaignGrids_AllConvRate',
};

export const allConversionRevenueOnAdSpendColumn: ColumnRawData = {
  key: 'AllConversionRevenueOnAdSpend',
  name: _TL_('All conv. return on ad spend'),
  format: ColumnFormat.PercentageValue,
  helpId: 'pop_BA_CampaignGrids_AllConvROAS',
};

export const allConversionAdvertiserReportedRevenue: ColumnRawData = {
  key: 'AllConversionAdvertiserReportedRevenue',
  name: _TL_('All conv. revenue'),
  format: ColumnFormat.Decimal,
  helpId: 'pop_BA_CampaignGrids_AllConvRevenue',
};

export const allConversionCPAColumn: ColumnRawData = {
  key: 'AllConversionCPA',
  name: _TL_('All conv. CPA'),
  format: ColumnFormat.Decimal,
  helpId: 'pop_BA_CampaignGrids_AllConvCPA',
};

export const averagePositionColumn: ColumnRawData = {
  key: 'AveragePosition',
  name: _TL_('Average Position'),
  helpId: 'Page_CampaignGrids_AvgPosition',
  format: ColumnFormat.Decimal,
};

export const submittedOfferCountColumn: ColumnRawData = {
  key: 'ProductsSubmitted',
  name: _TL_('Products Submitted'),
  format: ColumnFormat.Integer,
  helpId: 'pop_BA_BSC_ProductsSubmitted',
};

export const servableOfferCountColumn: ColumnRawData = {
  key: 'ProductsReadyToServe',
  name: _TL_('Products Ready to Serve'),
  format: ColumnFormat.Integer,
  helpId: 'pop_BA_BSC_ProductReadyToServe',
};

export const targetedOfferCountColumn: ColumnRawData = {
  key: 'ProductsTargeted',
  name: _TL_('Products Targeted'),
  format: ColumnFormat.Integer,
  helpId: 'pop_BA_BSC_ProductTargeted',
};

export const targetedOfferPercentageColumn: ColumnRawData = {
  key: 'ProductsTargeted_Percentage',
  name: _TL_('% Products Targeted'),
  format: ColumnFormat.PercentageValue,
  helpId: 'pop_BA_BSC_ProductsTargetPercentage',
};

export const urlCustomParametersColumn: ColumnRawData = {
  key: 'CustomParameters',
  name: _TL_('Custom parameters'),
  helpId: 'Page_CampaignsGrid_URLCustomParameters',
};

export const finalUrlSuffixColumn: ColumnRawData = {
  key: 'FinalUrlSuffix',
  name: _TL_('Final URL suffix'),
  helpId: 'pop_BA_NewAdCreate_FinalURLSuffix',
};

export const trackingUrlTemplateColumn: ColumnRawData = {
  key: 'TrackingTemplate',
  name: _TL_('Tracking template'),
  helpId: 'Page_CampaignsGrid_TrackingTemplate',
};

export const destinationUrlColumn: ColumnRawData = {
  key: 'DestinationUrl',
  name: _TL_('Destination URL'),
  helpId: 'Page_CampaignGrids_DestinationUrl',
};

export const eligibleImpressionsColumn: ColumnRawData = {
  key: 'EligibleImpressions',
  name: _TL_('Eligible impr.'),
};

export const missedImpressionsColumn: ColumnRawData = {
  key: 'MissedImpressions',
  name: _TL_('Missed impr.'),
};

export const impressionShareColumn: ColumnRawData = {
  key: 'ImpressionShare',
  name: _TL_('Impr. share'),
};

export const missedImpressionsNoBidColumn: ColumnRawData = {
  key: 'MissedImpressionsNoBid',
  name: _TL_('Missed impr. no bid'),
};

export const missedImpressionsSpendingCapReachedColumn: ColumnRawData = {
  key: 'MissedImpressionsSpendingCapReached',
  name: _TL_('Missed impr. spending cap reached'),
};

export const missedImpressionsInsufficientBidColumn: ColumnRawData = {
  key: 'MissedImpressionsInsufficientBid',
  name: _TL_('Missed impr. insufficient bid'),
};

export const missedImpressionsNoTaxColumn: ColumnRawData = {
  key: 'MissedImpressionsNoTax',
  name: _TL_('Missed impr. no tax'),
};

export const missedImpressionsOtherColumn: ColumnRawData = {
  key: 'MissedImpressionsOther',
  name: _TL_('Missed impr. other'),
};

export const averageCPSColumn: ColumnRawData = {
  key: 'AverageCPS',
  name: _TL_('Avg. CPS'),
  format: ColumnFormat.Decimal,
  helpId: 'pop_BA_CampaignGrids_CostPerSale',
};

export const salesCountColumn: ColumnRawData = {
  key: 'SalesCount',
  name: _TL_('Sales Count'),
  format: ColumnFormat.Integer,
  helpId: 'pop_BA_CampaignGrids_Sale',
};
